/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable-next-line jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

type Params = {
  id: number;
};

export function AdminOnlineStoreMod(routeProps: RouteComponentProps) {
  const [savedFile, setSavedFile] = useState<File>();
  const [savedFileName, setSavedFileName] = useState<string>('');
  const [savingFile, setSavingFile] = useState<File>();
  const [siteUrlText, setSiteUrlText] = useState('http://www.');
  const [nameText, setNameText] = useState('');
  const [fileUrl, setFileUrl] = useState('');
  const { match, location } = routeProps;
  const { id } = match.params as Params;
  const dispatch = useDispatch();
  const history = useHistory();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    if (+id > 0) {
      server.getOnlineStoreId(id).then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setNameText(payload.name);
          setSiteUrlText(payload.urlOnline);
          setSavedFile(payload.imageUrl);
          setSavedFileName(payload.image);
        }
      });
    }
  }, []);

  // 수정 버튼 클릭 시
  const updateOnlineStore = async () => {
    const savedData = await server
      .patchOnlineStore(id, {
        name: nameText,
        urlOnline: siteUrlText,
      })
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          dispatch(toast.info({ message: '정상적으로 저장되었습니다.' }));
        }
        history.push('/admin/store/online');
        return payload;
      });

    if (savedData !== undefined) {
      const savedDataId = savedData.id;
      if (savingFile !== undefined) {
        await server
          .patchOnlineStoreattache(savedDataId, { image: savingFile })
          .then(() => {
            history.push('/admin/store/online');
          })
          .catch((error) => {
            dispatch(toast.error({ message: '첨부파일 에러' }));
            return error;
          });
      }
    }
  };

  // 배너이미지 업로드
  const attachFileDom = () => {
    return (
      <li>
        <span className="">현재 서점 이미지</span>
        <span>
          <img
            src={savedFile ? `${process.env.REACT_APP_API_URL}/public/${savedFile}` : ''}
            alt={savedFileName}
          />
        </span>
      </li>
    );
  };

  // 테이블 생성
  function createOnlineStoreTable() {
    return (
      <main className="images wrapper">
        <ul className="inputs">
          {attachFileDom()}
          <li>
            <span className="required">등록할 서점 이미지</span>
            <div className="input-file-container">
              <input
                className="input-file"
                id="file02"
                type="file"
                onChange={(e) => {
                  if (
                    e.target !== null &&
                    e.target.files !== null &&
                    e.target.files[0] !== undefined
                  ) {
                    setSavingFile(e.target.files[0]);
                    const preview = e.target.files[0];
                    const imageUrl = URL.createObjectURL(preview);
                    setFileUrl(imageUrl);
                  }
                }}
              />
              <label tabIndex={0} htmlFor="file02" className="input-file-trigger">
                파일 선택
              </label>
            </div>
            <img
              src={fileUrl}
              alt=""
              onLoad={() => {
                dispatch(toast.info({ message: '이미지 업로드 완료.' }));
                window.URL.revokeObjectURL(fileUrl);
              }}
            />
            <small>※ 사이즈: 180x66 (픽셀)</small>
          </li>
          <li>
            <span>연결 URL</span>
            <input
              id="siteUrl"
              className="full"
              type="url"
              value={siteUrlText || ''}
              onChange={(e) => {
                setSiteUrlText(e.target.value);
              }}
            />
          </li>
          <li>
            <span>서점명</span>
            <input
              id="name"
              type="text"
              value={nameText || ''}
              onChange={(e) => {
                setNameText(e.target.value);
              }}
            />
            <small>※ 해당 서점명을 입력해주세요.</small>
          </li>
        </ul>
      </main>
    );
  }

  // AdminOnlineStoreMod 리턴값
  return (
    <main className="images wrapper">
      <div className="title">
        <h1>온라인 서점 수정하기</h1>
        <div className="buttons">
          <button type="button" onClick={updateOnlineStore}>
            수정
          </button>
        </div>
      </div>
      <div className="content">{createOnlineStoreTable()}</div>
    </main>
  );
}
